export const LOCAL_STORAGE_KEY = 'favorites';
export const LOCAL_STORAGE_SAVE_TIME = 200;
